import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import { CampaignSearchResponse } from '../models/campaign-management.model';

export const CostChanged = createAction(
  '[Campaign Management: Cost]: Cost Changed',
  props<{ cost: number }>(),
);

export const UpdateCost = createAction('[Campaign Management: Cost]: Update Cost');

export const UpdateCostSuccess = createAction(
  '[Campaign Management: Cost]: Update Cost Success',
  props<{ res: CampaignSearchResponse }>(),
);

export const UpdateCostFailed = createAction(
  '[Campaign Management: Cost]: Update Cost Failed',
  props<{ error: HttpErrorResponse }>(),
);
